/**
 * Shared LIVE policy for outgoing video requests.
 *
 * In LIVE the playhead must NOT be reported: the player `currentTime` is the
 * absolute presentation time, which for DASH manifests anchored at
 * `availabilityStartTime` is ~the Unix epoch (e.g. 1.78e9). If that value
 * leaks into NQS it is aggregated with MAX in ClickHouse and rendered in the
 * Suite "Cabezal de reproducción" as a huge `HH:MM:SS`. In LIVE we also set
 * `mediaDuration` from the `content.duration` option.
 *
 * This is the single source of truth applied by BOTH request paths:
 * `video._send` (every event) and `videoPing._sendPing` (periodic ping). The
 * ping flow does not go through `_send`, so before this helper existed it
 * skipped the strip and shipped the raw playhead on every LIVE ping.
 *
 * @param {boolean} isLive Result of `getIsLive()`. The strip only fires on a
 *   strict boolean `true`, matching the existing `_send` semantics.
 * @param {*} contentDuration Value to assign to `mediaDuration` in LIVE
 *   (typically `options['content.duration']`).
 * @param {Object} params Params object to sanitise in place.
 * @returns {Object} The same `params` object, mutated when LIVE.
 */
function applyLivePolicy(isLive, contentDuration, params) {
  if (isLive === true) {
    params.mediaDuration = contentDuration;
    params.playhead = undefined;
  }
  return params;
}

module.exports = { applyLivePolicy };
